import Highlighter from 'react-highlight-words';

import { Survey } from 'types/survey';
import { TranslationsKeys } from 'types/translation';
import { useTranslate } from 'hooks/useTranslate';
import { useSurveyTranslation } from 'hooks/useSurveyTranslation';
import { Button } from 'components/ui/Button';
import { getHighlighterProps } from '../util';
import styles from '../SurveyIntro.module.scss';

interface IProps {
  survey: Survey;
  onClick: () => void;
  surveyQuery: string;
}

export const SurveyDefinitionListEntry = ({ surveyQuery, survey, onClick }: IProps) => {
  const { t } = useTranslate();
  const ts = useSurveyTranslation(survey);

  return (
    <div key={survey.surveyDefinitionId} className={styles.surveyIntroSurveySearchSurveyTemplatesSurveyTemplate}>
      <div className={styles.surveyIntroSurveySearchSurveyTemplatesSurveyTemplateName}>
        <div>
          <Highlighter {...getHighlighterProps(ts(survey.name), surveyQuery)} />
        </div>
        <div>
          <Button
            variant="primary"
            size="small"
            aria-label={t(TranslationsKeys.surveyIntroPage_noCustomerConfirmationAddCustomerButtonText)}
            onClick={onClick}>
            {t(TranslationsKeys.common_select)}
          </Button>
        </div>
      </div>
      <div className={styles.surveyIntroSurveySearchSurveyTemplatesSurveyTemplateInfo}>
        <div className={styles.surveyIntroSurveySearchSurveyTemplatesSurveyTemplateInfoRow}>
          <Highlighter {...getHighlighterProps(ts(survey.sector), surveyQuery)} />
        </div>
        <div className={styles.surveyIntroSurveySearchSurveyTemplatesSurveyTemplateInfoRow}>
          <div>{t(TranslationsKeys.common_version)}:</div>
          <div>{survey.version}</div>
        </div>
      </div>
    </div>
  );
};
